import { createSlice } from '@reduxjs/toolkit';

export const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    fonts: [],
    users: [],
    loadingFonts: false,
    loadingUsers: false,
    fontsError: false,
    usersError: false,
  },
  reducers: {
    setUsersLoading: (state, action) => {
      state.loadingUsers = action.payload;
      state.usersError = false;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
      state.loadingUsers = false;
      state.usersError = false;
    },
    setUsersError: (state, action) => {
      state.usersError = action.payload;
      state.loadingUsers = false;
    },
    setFontsLoading: (state, action) => {
      state.loadingFonts = action.payload;
      state.fontsError = false;
    },
    setFonts: (state, action) => {
      state.fonts = action.payload;
      state.loadingFonts = false;
      state.fontsError = false;
    },
    setFontsError: (state, action) => {
      state.fontsError = action.payload;
      state.loadingFonts = false;
    },
  },
});

export const {
  setFonts,
  setUsers,
  setFontsLoading,
  setUsersLoading,
  setFontsError,
  setUsersError,
} = adminSlice.actions;

export default adminSlice.reducer;
